import { entitiesSortedByCountry } from "utils/entitiesSortedByCountry";
import { useCurrentGroup } from "./useCurrentGroup";

const EMPTY_ENTITIES: ReturnType<typeof useCurrentGroup>["entities"] = [];

export const useDefaultEntity = () => {
  const { entities = EMPTY_ENTITIES } = useCurrentGroup();
  const { sortedEntities } = entitiesSortedByCountry(entities);

  return sortedEntities[0];
};
